import React, { useEffect, useState } from 'react';
import ServiceCollection from "src/services/ServiceCollection";
import { initialState, ReportsState } from 'src/services/reports/ReportsState';
import TPEAction from 'src/models/common/TPEAction';
import useReducerWithLogger from 'src/services/utils/ReducerWithLogger';
import { reportsReducer } from 'src/services/reports/ReportsReducer';
import { Tabs, Spinner } from '@amzn/awsui-components-react';
import ReportMetricsDashboard from './ReportMetricsDashboard';
import ReportViewDashboard from './ReportViewDashboard';
import { getFeatureFlags, isFeatureEnabledForUser } from 'src/services/FeatureFlagsService';
export type ContextType = {
    state: ReportsState,
    dispatch: React.Dispatch<TPEAction>,
    services: ServiceCollection,
}

export const ReportDashboardContext = React.createContext(null as ContextType | null);


const ReportDashboardProvider = (props: {
    state: ReportsState, dispatch: React.Dispatch<TPEAction>, services: ServiceCollection,
    children: JSX.Element
}) => {
    const { state, dispatch, services, children } = props;
    const providerValue = React.useMemo(() => ({
        state, dispatch, services
    }), [state, dispatch]);
    return (
        <ReportDashboardContext.Provider value={providerValue}>
            {children}
        </ReportDashboardContext.Provider>
    );
}
export default function ReportDashboard(props: { services: ServiceCollection }) {
    const { services } = props;
    const [state, dispatch] = useReducerWithLogger(reportsReducer, initialState);
    const [activeTabId, setActiveTabId] = useState('reportsView');
    const [metricsEnabled, setMetricsEnabled] = useState(false);
    const [flagsLoading, setFlagsLoading] = useState(true);

    useEffect(() => {
        const userAlias = localStorage.getItem('alias') || '';
        getFeatureFlags().then((flags) => {
            setMetricsEnabled(isFeatureEnabledForUser(flags, 'metricsDashboardEnabled', userAlias));
        }).catch((err) => {
            console.error('Failed to load feature flags', err);
        }).finally(() => {
            setFlagsLoading(false);
        });
    }, []);

    const tabs = [
        {
            label: 'Metrics',
            id: 'metrics',
            content: flagsLoading
                ? <Spinner size="large" />
                : <ReportMetricsDashboard services={services} metricsEnabled={metricsEnabled} />,
        },
        {
            label: 'View Reports',
            id: 'reportsView',
            content: <ReportViewDashboard services={services} />,
        }
    ];

    return (<ReportDashboardProvider state={state} dispatch={dispatch} services={services}>
        <div>
            <Tabs
                onChange={({ detail }) => {
                    setActiveTabId(detail.activeTabId)
                }}
                activeTabId={activeTabId}
                tabs={tabs}
            />
        </div>

    </ReportDashboardProvider>)

};



